import moment from 'moment'
import immutable from 'immutable'
import Guid from 'guid'

import {
    PREPEND_DAY,
    APPEND_DAY,
    REMOVE_DAY,
    UPDATE_ARRIVAL_DATE,
    UPDATE_DEPARTURE_DATE,
    UPDATE_TOTAL_DAYS,
    UPDATE_TRIP_TITLE,
    UPDATE_ITIN_NAME,
    UPDATE_ORIGIN,
    UPDATE_RETURN,
    UPDATE_ORIGIN_TO_RETURN,
    UPDATE_RETURN_TO_ORIGIN
} from '../planner/planner.action'

import {
    INIT_STATE,
    INIT_STATE_ORDER,
    PROGRESS_INIT_STATE,
    REGRESS_INIT_STATE
} from '../init/initialdata.action'

import {
    ADD_LEG
} from '../leg/leg.action'


export default (state, action) => {
    switch (action.type) {
        case PREPEND_DAY:
            let arrivalDate = state.get('arrivalDate')
            if (arrivalDate) {
                state = state.update('arrivalDate',
                    (newDate) => moment(arrivalDate).subtract(1, 'days')
                )
            }
            return state.update('totalDays', (totalDays) => totalDays + 1)
        case APPEND_DAY:
            let departureDate = state.get('departureDate')
            if (departureDate) {
                state = state.update('departureDate',
                    (newDate) => moment(departureDate).add(1, 'days').toISOString()
                )
            }
            return state.update('totalDays', (totalDays) => totalDays + 1)
        case REMOVE_DAY:
            state = state.update('totalDays', (totalDays) => totalDays - 1)

            let departure = moment(state.get('departureDate'))
            if (departure.isValid()) {
                state = state.set('departureDate', departure.subtract(1, 'days').toISOString())
            }

            return state
        case UPDATE_ARRIVAL_DATE:
            state = state.update('arrivalDate', (arrivalDate) => action.date ? action.date.toISOString() : null)

            let totalDays = state.get('totalDays')
            let arrival = moment(state.get('arrivalDate'))
            departure = moment(state.get('departureDate'))

            if (arrival.isValid() && departure.isValid()) {
                let duration = moment.duration(moment(departure).diff(arrival))

                state = state.update(
                    'totalDays', (total) => duration.asDays() || defaultTotalDays
                )
            } else if (!departure.isValid()) {
                // no departure date is set yet
                state = state.set('departureDate', arrival.add(totalDays, 'days').toISOString())
            }

            return state
        case UPDATE_DEPARTURE_DATE:
            state = state.update('departureDate', (departureDate) => action.date ? action.date.toISOString() : null)

            totalDays = state.get('totalDays')
            arrival = moment(state.get('arrivalDate'))
            departure = moment(state.get('departureDate'))

            if (arrival.isValid() && departure.isValid()) {
                let duration = moment.duration(moment(departure).diff(arrival))

                state = state.update(
                    'totalDays', (total) => duration.asDays() || defaultTotalDays
                )
            } else if (!arrival.isValid()) {
                // no arrival is set yet
                state = state.set('arrivalDate', departure.subtract(totalDays, 'days').toISOString())
            }

            return state
        case UPDATE_TRIP_TITLE:
            console.log('about to update title')
            return state.set('tripTitle', action.tripName)
        case UPDATE_ITIN_NAME:
            return state.set('itinTitle', action.itinName)
        case UPDATE_TOTAL_DAYS:
            if (action.tripLength) {
                state = state.update('totalDays', (totalDays) => action.tripLength || 1)
            } else {
                let arrival = moment(state.get('arrivalDate'))
                let departure = moment(state.get('departureDate'))
                let totalDays = state.get('totalDays')
                let defaultTotalDays = totalDays > 0 ? totalDays : 1
                if (arrival.isValid() && departure.isValid()) {
                    let duration = moment.duration(departure.diff(arrival))

                    state = state.update(
                        'totalDays', (total) => duration.asDays() || defaultTotalDays
                    )
                }
            }
            return state
        case PROGRESS_INIT_STATE:
            let currentStateProgress = state.get('initStep')

            let idxProgress = INIT_STATE_ORDER.indexOf(currentStateProgress)

            if (idxProgress === -1) {
                return state
            } else if (idxProgress === (INIT_STATE_ORDER.length - 1)) {
                // nowhere to go from here
                return state
            }

            return state.set('initStep', INIT_STATE_ORDER[idxProgress + 1])
        case REGRESS_INIT_STATE:
            let currentStateRegress = state.get('initStep')

            let idxRegress = INIT_STATE_ORDER.indexOf(currentStateRegress)

            if (idxRegress === -1) {
                return state
            } else if (idxRegress === 0) {
                // nowhere to go from here
                return state
            }
        case ADD_LEG:
            // wipe out init state
            return state.set('initStep', null)
        case UPDATE_ORIGIN:
            let newOrigin = immutable.fromJS({
                'id': Guid.raw(),
                'destination': {
                    'id': action.location.id,
                    'title': action.location.name,
                    'location': {
                        'longitude': action.location.longitude || action.location.opencage.location.lon,
                        'latitude': action.location.latitude || action.location.opencage.location.lat
                    }
                }
            })
            return state.set('origination', newOrigin)
        case UPDATE_RETURN:
            let newDeparture = immutable.fromJS({
                'id': Guid.raw(),
                'destination': {
                    'id': action.location.id,
                    'title': action.location.name,
                    'location': {
                        'longitude': action.location.opencage.location.lon ? action.location.opencage.location.lon : action.location.longitude,
                        'latitude': action.location.opencage.location.lat ? action.location.opencage.location.lat : action.location.location
                    }
                }
            })
            return state.set('return', newDeparture)
        case UPDATE_ORIGIN_TO_RETURN:
            return state.set('origination', action.location)
        case UPDATE_RETURN_TO_ORIGIN:
            return state.set('return', action.location)
        default:
            return state
    }
}
